import React from "react";
import { TEAMUP_ENABLED } from "Constants";

function AiProbability({
  aiConfidenceScore,
  probabilityNonZero,
  probabilitySettlement,
  aiEarlySettlementRecommendation,
  aiSuitability,
  aiEstimateLowerValue,
  aiEstimateUpperValue,
}) {
  const recommendationText = {
    STRONGLY_RECOMMENDED: "Strongly recommended",
    RECOMMENDED: "Recommended",
    NOT_RECOMMENDED: "Not recommended",
  };

  const recommendationColor = {
    STRONGLY_RECOMMENDED: "bg-[rgba(138,98,49,.1)] text-tan border-[rgba(138,98,49,.25)]",
    RECOMMENDED: "bg-[rgba(20,33,61,.06)] text-navy border-[rgba(20,33,61,.15)]",
    NOT_RECOMMENDED: "bg-red-50 text-red-700 border-red-200",
  };

  const hasRange = aiEstimateLowerValue != null && aiEstimateUpperValue != null;

  return (
    <div className="font-plexsans">
      <h2 className="text-2xl font-spectral text-navy mb-4">
        Case Outlook
      </h2>

      {hasRange && (
        <div className="rounded-[10px] bg-[rgba(20,33,61,.03)] border border-[rgba(20,33,61,.06)] px-6 py-6 flex flex-col items-center text-center mb-4">
          <div className="text-[11px] tracking-[0.1em] font-medium text-[rgba(20,33,61,.45)] uppercase">
            Estimated settlement range
          </div>
          <div className="flex items-baseline gap-3 mt-2 font-spectral">
            <span className="text-[26px] lg:text-[32px] font-semibold text-tan">
              ${Number(aiEstimateLowerValue).toLocaleString()}
            </span>
            <span className="text-sm text-[rgba(20,33,61,.4)]">to</span>
            <span className="text-[26px] lg:text-[32px] font-semibold text-tan">
              ${Number(aiEstimateUpperValue).toLocaleString()}
            </span>
          </div>
          <div className="text-[12px] text-[rgba(20,33,61,.45)] mt-2 max-w-[420px]">
            Modeled from comparable case data, filing details, and documentation strength.
          </div>
        </div>
      )}

      <div className="grid grid-cols-2 gap-3">

        <div className={`border border-[rgba(20,33,61,.12)] rounded-[10px] p-4 ${TEAMUP_ENABLED ? '' : 'col-span-2'}`}>
          <div className="text-[13px] text-[rgba(20,33,61,.5)]">
            Confidence
          </div>
          <div className="text-2xl font-semibold text-navy mt-1">
            {aiConfidenceScore}/10
          </div>
          <div className="text-[12px] text-[rgba(20,33,61,.45)] mt-1">
            How reliable this estimate is given current case data.
          </div>
        </div>

        {/* litigation funder suitability - hidden until funders launch */}
        {TEAMUP_ENABLED && (
          <div className="border border-[rgba(20,33,61,.12)] rounded-[10px] p-4">
            <div className="text-[13px] text-[rgba(20,33,61,.5)]">
              Suitability
            </div>
            <div className="text-2xl font-semibold text-navy mt-1">
              {aiSuitability}/10
            </div>
            <div className="text-[12px] text-[rgba(20,33,61,.45)] mt-1">
              Fit for the platform relative to other case types firms take on.
            </div>
          </div>
        )}

        <div className="border border-[rgba(20,33,61,.12)] rounded-[10px] p-4">
          <div className="text-[13px] text-[rgba(20,33,61,.5)]">
            Recovery chance
          </div>
          <div className="text-2xl font-semibold text-tan mt-1">
            {probabilityNonZero}
          </div>
          <div className="text-[12px] text-[rgba(20,33,61,.45)] mt-1">
            Likelihood of recovering some amount based on similar filings.
          </div>
        </div>

        <div className="border border-[rgba(20,33,61,.12)] rounded-[10px] p-4">
          <div className="text-[13px] text-[rgba(20,33,61,.5)]">
            Settlement chance
          </div>
          <div className="text-2xl font-semibold text-tan mt-1">
            {probabilitySettlement}
          </div>
          <div className="text-[12px] text-[rgba(20,33,61,.45)] mt-1">
            Likelihood this resolves before trial rather than going to verdict.
          </div>
        </div>

      </div>

      <div className="mt-3 flex items-center justify-between gap-3 border border-[rgba(20,33,61,.12)] rounded-[10px] p-4 bg-[rgba(20,33,61,.02)]">
        <span className="text-[14px] text-[rgba(20,33,61,.6)]">
          Early settlement recommendation
        </span>

        <span
          className={`inline-flex items-center px-3 py-1 rounded-full border text-[13px] font-medium whitespace-nowrap ${
            recommendationColor[aiEarlySettlementRecommendation] ||
            "bg-[rgba(20,33,61,.05)] text-[rgba(20,33,61,.6)] border-[rgba(20,33,61,.15)]"
          }`}
        >
          {recommendationText[aiEarlySettlementRecommendation] || aiEarlySettlementRecommendation}
        </span>
      </div>

    </div>
  );
}

export default AiProbability;
